module.exports = __webpack_public_path__ + "img/DB1_LOGO.7407dc14.png";